import type { CSSProperties } from 'styled-components';

export function transformStylesToVariants(
  stylesObj: Record<string, CSSProperties>,
  variantStyleName: string
) {
  const variantStyles = {} as Record<string, Record<string, CSSProperties>>;

  Object.entries(stylesObj).forEach(([styleName, style]) => {
    variantStyles[styleName] = {
      [variantStyleName]: style,
    };
  });

  return variantStyles;
}
